<template>
  <el-form ref="form" :rules="rules" :model="form" @change.native="handleFormChange" label-position="left">
    <el-form-item prop="contractType" label="合同类型">
      <el-radio-group v-model="form.contractType" @change="resetFields">
        <el-radio label="DISTRIBUTE">分散式合同</el-radio>
        <el-radio v-if="!isRenew" label="CENTRALIZE">集中式合同</el-radio>
      </el-radio-group>
    </el-form-item>

    <div v-if="form.contractType === 'CENTRALIZE'">
      <el-form-item prop="unitId" label="片区" label-width="5.6em">
        <el-cascader v-model="form.unitId" placeholder="请选择片区" style="width:18em;" ref="cascader" :options="unitOptions"></el-cascader>
      </el-form-item>
      <el-form-item prop="blockName" label="社区名称">
        <el-autocomplete style="width:18em;" v-model="form.blockName" :fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请选择社区名称" @select="handleSelect" @focusout.native="handleBlur" />
        <span class="field-tip">(输入的内容将作为对应房源的社区名称)</span>
      </el-form-item>

      <el-form-item prop="contractName" label="合同名称">
        <el-input style="width:18em;" name="contractName" v-model="form.contractName" placeholder="请输入合同名称" />
        <span class="field-tip">(合同名称格式：社区名称+楼栋A+楼栋B...)</span>
      </el-form-item>
    </div>
    <template v-else-if="form.contractType === 'DISTRIBUTE'">
      <el-form-item prop="unitId" label="片区" label-width="5.6em">
        <el-input v-if="isRenew" v-model="form.unitName" style="width:18em;" disabled />
        <el-cascader v-else v-model="form.unitId" placeholder="请选择片区" style="width:18em;" ref="cascader" :options="unitOptions"></el-cascader>
      </el-form-item>

      <div class="line-combine">
        <el-form-item prop="blockName" label="房源地址" style="display:flex; margin-right:1.2em;">
          <el-autocomplete style="width:18em;" v-model="form.blockName" :fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请选择小区名称" @select="handleSelect" @focusout.native="handleBlur" :disabled="isRenew" />
          <!-- <el-input
          style="width:18em;"
          name="houseAddr"
          v-model="form.houseAddr"
          placeholder="地址"
          />-->
        </el-form-item>

        <div class="line-combine__inner-row">
          <el-form-item prop="tung" label>
            <el-input style="width:3em;" name="tung" v-model="form.tung" placeholder="栋" :disabled="isRenew" />

            <span>栋</span>
          </el-form-item>
          <el-form-item prop="unit" label>
            <el-input style="width:4em;" name="unit" v-model="form.unit" placeholder="单元" :disabled="isRenew" />
            <span>单元</span>
          </el-form-item>
          <el-form-item prop="number" label>
            <el-input style="width:5em;" name="number" v-model="form.number" placeholder="室" :disabled="isRenew" />
            <span>室</span>
          </el-form-item>
        </div>
      </div>
      <el-form-item prop="ownershipCertificateAddress" class="line-combine" label="详细地址" >
        <el-input v-model="form.ownershipCertificateAddress" placeholder="请输入产权证上的地址"  style="width:30em;"></el-input>
      </el-form-item>
    </template>

    <el-form-item prop="pictures" label="上传合同照片" class="picture-item">
      <el-upload :action="ossBaseUrl" accept="image/*" :file-list="form.pictures" list-type="picture-card" :auto-upload="false" :on-change="onUploadChange">
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>
  </el-form>
</template>

<script>
import { uploadFiles } from '@/xhr/services/oss'
// import workflowXHR from '@/xhr/services/workflow'
import centralApi from '@/xhr/services/central'
import { fetchBlocks, fetchUnitOptions, fetchHouseSpace, fetchHouseaddress} from './fetch'
import { getCascaderLabel, isObject } from './utils'
import { k1 } from '@/xhr/services/osssp'

export default {
  inject: ['defaultForm'],

  data () {
    // 新增房东合同发起接口
    this.postMethod = centralApi.newAndRenewLandlordContract

    return {
      ossBaseUrl: 'http://' + k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6 + '.' + k1.a_4 + '-' + k1.a_3 + '-' + k1.a_0 + '.' + k1.a_2 + k1.a_8 + k1.a_1 + '.com/',

      form: {
        contractType: 'DISTRIBUTE',
        blockName: '',
        blockId: '',
        ownershipCertificateAddress: '', // 详细地址
        contractName: '',
        // houseAddr: '',
        tung: '',
        unit: '',
        number: '',
        pictures: [],
        unitId: null,
      },

      zones: [],

      unitOptions: [],
    }
  },

  computed: {
    // 是否续租
    isRenew () {
      return isObject(this.defaultForm)
    },

    rules () {
      if (this.form.contractType === 'DISTRIBUTE') {
        return {
          contractType: [{ required: true, message: '此项不能为空' }],
          // blockId: [{ required: true, message: '此项不能为空' }],
          unitId: [{ required: true, message: '此项不能为空' }],
          blockName: [{ required: true, message: '此项不能为空' }],
          number: [{ required: true, message: '此项不能为空' }],
          // houseAddr: [{ required: true, message: '此项不能为空' }],
          ownershipCertificateAddress: [{ required: true, message: '此项不能为空', trigger: 'blur', }],
          pictures: [
            {
              required: true,
              message: '此项不能为空',
              trigger: 'blur',
              type: 'array',
            },
          ],
        }
      } else {
        return {
          contractType: [{ required: true, message: '此项不能为空' }],
          unitId: [{ required: true, message: '此项不能为空' }],
          blockName: [
            { required: true, message: '此项不能为空', trigger: 'blur' },
          ],
          contractName: [
            { required: true, message: '此项不能为空', trigger: 'blur' },
          ],
          pictures: [
            {
              required: true,
              message: '此项不能为空',
              trigger: 'blur',
              type: 'array',
            },
          ],
        }
      }
    },
  },
  mounted () {
    this.formEl = this.$refs.form
    // typeof this.setUnitIds === 'function' && this.setUnitIds() // 修改续签合同闪退问题 进入续签弹窗 不再变更随寓片区ID为个人携带片区ID
    fetchUnitOptions().then(unitOptions => {
      this.unitOptions = unitOptions
    })
    if (this.isRenew) {
      // console.log({ defaultForm: this.defaultForm }, '2324242')
      /* dsfsdfs */
      fetchHouseSpace(this.defaultForm.houseSpaceId).then(data => {
        // debugger
        this.form.blockName = data.blockName
        this.form.blockId = data.blockId
        this.form.unitId = data.zoneId
        this.form.unitName = data.zone
        this.form.unit = data.unitNo
        this.form.number = data.roomNo
        this.form.tung = data.buildingNo
        this.form.companyId = data.companyId
      })
      fetchHouseaddress(this.defaultForm.id).then(data => {
        // debugger
        this.form.ownershipCertificateAddress = data.houseOwnershipCertificateAddress
      })
    }
  },
  methods: {
    noop () { },
    resetFields () {
      this.form.blockName = ''
      this.form.blockId = ''
      this.form.unitId = null
      this.form.ownershipCertificateAddress = ''
      this.form.contractName = ''
      this.form.tung = ''
      this.form.unit = ''
      this.form.number = ''
      this.form.pictures = []
    },

    querySearch (kw, cb) {
      this.form.blockId = null
      fetchBlocks(kw).then(blocks => {
        cb(blocks.map(item => ({ value: item.label, label: item.value })))
      })
    },
    handleBlur () {
      if (!this.form.blockId) {
        this.form.blockName = null
      }
    },
    handleSelect (item) {
      this.form.blockId = item.label
    },
    handleFormChange (e) {
      this.emitChange(this.form)
    },
    emitChange (form) {
      this.$emit('change', form, this.$refs.form)
    },
    onUploadChange (file, fileList) {
      this.form.pictures = fileList
    },

    submit (
      onSuccess = this.noop,
      onComplete = this.noop,
      onRequest = this.noop
    ) {
      if (this.formEl) {
        this.formEl.validate(async valid => {
          if (!valid) return

          typeof onRequest === 'function' && onRequest()
          const pictures = await this.upload()
          this._submit(
            {
              ...this.form,
              pictures,
            },
            onSuccess,
            onComplete,
            onRequest
          )
        })
      }
    },

    r (val, suffix) {
      return val || val === 0 ? val + suffix : ''
    },

    async _submit (form, onSuccess, onComplete, onRequest) {
      let processBusinessKey
      // 如果是集中式
      if (form.contractType === 'CENTRALIZE') {
        // delete form.houseAddr
        delete form.tung
        delete form.unit
        delete form.number

        const { blockId } = form
        if (Array.isArray(blockId) && blockId.length === 2) {
          form.blockId = blockId[1]
          form.blockName = getCascaderLabel(blockId, this.zones)
        }
        if (Array.isArray(form.unitId) && form.unitId.length === 2) {
          form.unitId = form.unitId[1]
          form.unitName = this.$refs.cascader.$el
            .querySelector('.el-cascader__label')
            .innerText.split('/')[1]
            .trim()
        }

        processBusinessKey = 'process-landlord-focus-contract-focus-v1'
      } else {
        // delete form.blockId
        const r = this.r
        form.contractName = `${form.blockName}${r(form.tung, '栋')}${r(
          form.unit,
          '单元'
        )}${r(form.number, '室')}`
        form.houseAddr = form.contractName
        if (Array.isArray(form.unitId) && form.unitId.length === 2) {
          form.unitId = form.unitId[1]
          form.unitName = this.$refs.cascader.$el
            .querySelector('.el-cascader__label')
            .innerText.split('/')[1]
            .trim()
        }

        if (this.isRenew) {
          form.oldContractId = this.defaultForm.id
          form.houseSpaceId = this.defaultForm.houseSpaceId
        }

        // 分散式，新签或者续签
        processBusinessKey = this.isRenew
          ? 'process-renew-landlord-contract-v1'
          : 'process-landlord-focus-contract-decent-v1'
      }

      form.processScopeId = this.$store.state.area.currentUnitIds[0]

      const _form = {
        initiator: this.getUid(),
        processBusinessKey,
        processInstanceName: '房东合同录入流程',
        processScopeId: form.unitId || this.$store.state.area.currentUnitIds[0], // blockId,
        variables: form,
      }

      try {
        typeof onRequest === 'function' && onRequest()
        const res = await this.postMethod(this.isRenew, _form)
        typeof onComplete === 'function' && onComplete()
        if (res.data.code === 200) {
          this.$message.success('操作成功')
          typeof onSuccess === 'function' && onSuccess(res.data.data)
        } else if (res.data.code !== 401 && res.data.code !== 403) {
          this.$message.error(`操作失败。${res.data.message}`)
          return
        }
      } catch (e) {
        typeof onComplete === 'function' && onComplete()
        this.$message.error(e.message)
      }
    },

    async upload () {
      try {
        const pictures = await uploadFiles(this.form.pictures)
        return JSON.stringify(pictures.map(item => item.url))
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}
</script>

<style lang="scss">
.line-combine {
  display: flex;
  .el-form-item {
    margin-right: 1em;
  }
}
.line-combine__inner-row {
  display: flex;
  input {
    text-align: center;
  }
}

.picture-item {
  .el-form-item__error {
    display: none;
  }
}

.field-tip {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/page/none/workflow/trusteeship/forms/start-form.vue